<template>
      <v-dialog v-model="visible" width="400">
        <v-card class="overflow-x-hidden">
          <v-row class="px-2 ml-1">
            <v-card-title class="mt-2 mb-2">{{"modal_header_warning" | localize}}</v-card-title>
            <v-spacer></v-spacer>
            <v-icon class="px-2 mr-1 mt-2 mb-2" @click="$emit('close')"
              >mdi-close-thick</v-icon
            >
          </v-row>
          <v-card-text class="ml-3">
            <span>{{"manage_profile_alert_delete_manager" | localize}}</span></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn width="100"  color='#72AFE7' dark @click="$emit('delete')">
              OK
            </v-btn>
            <v-btn width="100"  color='#72AFE7' outlined @click="$emit('close')">
              {{ "promotion_cancel" | localize }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
export default {
  props: {
    visibility: {
      require: true,
    },
  },
  computed: {
    visible: {
      get() {
        return this.visibility;
      },
      set() {
        this.$emit("close");
      },
    },
  },
};
</script>

<style>
</style>